{
  "agb-form": {
    "text": {
      "accept": "Tôi chấp nhận ",
      "agb": "Điều khoản chung"
    }
  }
}
